// Meta Ads Insights pipeline settings, stored via the generic dashboard settings store
// (namespace below), read/written through SettingsService. These defaults and the hard
// token-budget cap mirror the backend (sbly-dash-collector src/meta-ads-insights/settings.js
// + pipeline/constants). The backend clamps authoritatively; these are only for seeding
// the form and rendering the allowed range.
export const META_ADS_SETTINGS_NAMESPACE = 'meta_ads_insights';
export const DEFAULT_MIN_D7_SPEND = 100;
export const DEFAULT_TOKEN_BUDGET = 33333; // ≈ $0.50 of Sonnet 4.6 output
export const MAX_TOKEN_BUDGET = 100000; // hard ceiling (also enforced server-side)
